import { ref, computed } from '@vue/composition-api';
import api from '@/api';
import readonly from '@/helpers/readonly';
import cloneDeep from 'lodash/cloneDeep';

const state = ref({});
export default computed(() => readonly(state.value));

export const getCurrentUser = () => {
    return api.profile.list()
        .then(({ data }) => {
            const response = data.data;
            response.isAdmin = response.admin === 'y';
            response.isSuperAdmin = response.superadmin === 'y';

            delete response.admin;
            delete response.superadmin;

            if (response.isAdmin || response.isSuperAdmin) {
                delete response.privileges;
            }

            state.value = response;
        });
};

export const setCurrentUser = (model) => {
    state.value = cloneDeep(model.value);
};

export const resetCurrentUser = () => {
    state.value = {};
};

